export default "__VITE_ASSET__BHkDq4ge__"